var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_vm._v("\n        코인 결제\n    ")]),_c('v-card',[_vm._v("\n        구독 상품\n    ")]),_c('v-card',[_vm._v("\n        단일 상품\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }